"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.McpToolApprovalPolicy = void 0;
exports.McpToolApprovalPolicy = {
    AutoApproved: "auto_approved",
    RequiresApproval: "requires_approval",
};
